import axios from 'axios';
import endsWith from 'lodash/endsWith';

export const baseURL = (process.env.NODE_ENV === 'development'
  ? 'http://api.anturium.redis.tv/'
  : 'https://api.anturium.agency/');

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;


export async function getData(url, params) {
  let path = `/api${url}`;
  if (!endsWith(path, '/')) {
    path = `${path}/`;
  }

  const response = await axios(path, params, {
    port: 8000,
  });
  return response.data;
}



// WEBPACK FOOTER //
// ./src/utils/api.js